/***************************************************************************************************

 Copyright 2023-2024 Fannie Mae. All rights reserved.
 This software contains confidential information and trade secrets of Fannie Mae.
 Use, disclosure, or reproduction is prohibited without the prior written consent of Fannie Mae.

 ****************************************************************************************************/

 import { Component, ElementRef, HostListener, Inject, LOCALE_ID, OnInit, RendererFactory2, ViewChild } from '@angular/core';
 import { DataFilesDetails, SubmittedFilesData } from "src/app/model/DataFilesDetails";
 import { UserInformation } from "src/app/model/UserInformation";
 import { DashboardService } from "src/app/services/dashboard.service";
 import { ApiService } from "src/app/services/api.service";
 import { FileUploadService } from "src/app/services/file-upload.service";
 import { Errors, FileStatus, UploadedFilesData, Warnings } from "src/app/model/UploadedFilesData";
 import { EndpointsService } from "src/app/services/endpoints.service";
 import { HttpClient } from "@angular/common/http";
 import { ActivatedRoute, Router } from "@angular/router";
 import { SellerServiceNumberService } from "src/app/services/sellerservicernumber.service";
 import { SellerServicerNumber } from 'src/app/model/SellerServicerNumber';
 import { AppConstants } from 'src/app/shared/app.constants';
 import { Utils } from "src/app/shared/utils";
 import * as _ from 'lodash-es';
 import { ConfirmationService } from '@fm-ui-adk/components-3/common/services';
 import { DocWayDetailsService } from "src/app/services/docwaydetails.service";
 import { SellerServicerData } from "src/app/model/SellerServicerData";
 import { UserDetails } from "src/app/model/UserDetails";
 import { CDXUploadedFilesList } from "src/app/model/CDXUploadedFilesList";
 import { InsuranceAcquisitionDetails } from "src/app/model/InsuranceAcquisitionDetails";
 import { MenuItem } from '@fm-ui-adk/components-3/common/model';
 import { LaunchDarklyUtil } from 'src/app/shared/launch-darkly-util';
 import { Acquisitions_Util } from "src/app/insurance/util/acquisitions.util";
 import { AcqnFilterService } from 'src/app/services/acqn-filter-service';
 import { AcqnFiltersDetails } from 'src/app/insurance/model/AcqnFiltersDetails';
 import { StatsDataService } from 'src/app/services/stats-data.service';
 import { UserRolesService } from 'src/app/services/user-roles.service';
 import { AqsnPropertyDetailsService } from 'src/app/services/aqsn-property-details.service';
 import { DDTabName, FileUploadSourceType, FilterDetailsSourceType } from 'src/app/shared/enum-value';
import { InsuranceService } from '../services/insurance.service';

 @Component({
   standalone: false,
   selector: 'app-data-standard',
   templateUrl: './insurance.component.html',
   styleUrls: ['./insurance.component.css'],
   providers: [DashboardService]
 })

 export class InsuranceComponent implements OnInit {
   @ViewChild('dialog1', { read: ElementRef }) dialogRef: ElementRef;

   display1: boolean = false;
   alertMessage: string;
   cols1: any[];
   cols2: any[];
   cols3: any[];
   cols3_bpo: any[];
   cols4: any[];
   dataFilesDetails: DataFilesDetails;
   dataFilesDetailsDashboardDisplay: SubmittedFilesData[] = [];
   dataFilesLenderList: any[] = [];
   dataFilesSelectedLender: string = "";
   userInfoArray: UserInformation[] = [];
   sellerServicerDataArray: SellerServicerData[] = [];
   roles: any[];
   userId: string;
   cfmlycode: string;
   uploadedFilesArray: UploadedFilesData[] = [];
   uploadedFilesArrayTemp: UploadedFilesData[] = [];
   submittedFilesArray: UploadedFilesData[] = [];
   selectedFilesArray: FileStatus[] = [];
   uploadedFilesArrayDisplay: FileStatus[] = [];
   dealId: string;
   selected: number;
   errors: Errors[] = [];
   warnings: Warnings[] = [];
   status: UploadedFilesData;
   showWarnings: boolean;
   showErrors: boolean;
   fileType: any[];
   originalName: string;
   newName: string;
   newNameSplit: any[];
   fileRejectedError: boolean;
   fileRejectedErrorWarning: boolean;
   fileWarning: boolean;
   row: number;
   masterRecord: boolean;
   public alertFeedback: any = [];
   sellerServicerNumber: SellerServicerNumber;
   lenderName: string;
   sellerServicerNoParent: string;
   userDetails: UserDetails;
   disableUpload: boolean = false;
   steps;
   currentStep;
   screenHeight: number;
   modalScreenHeight: number;
   modalTableHeight: string;
   screenWidth: number;
   modalScreenWidth: number;
   dataFilesFilterBinding: string;
   acquisitionsFilterBinding: string;
   lenderRankingFilterBinding: string;
   warningCount: Number;
   errorCount: Number;
   issueSummary: string;
   rowData;
   showIssueSummary: boolean;
   showIssueSummaryPreview: boolean;
   objectKey: string;
   selectedFileCount: number;
   isLoading: boolean = false;
   isLoadingInsurance: boolean = false;
   navigationLinks: any[];
   selectFilesTouched: boolean = false;
   finishAndCloseClicked: boolean = false;
   tableSubtitle: string;
   tableNoSubmittedFilesMessage: string;
   cdxUploadedFilesList: CDXUploadedFilesList[] = [];

   acqnDetails: InsuranceAcquisitionDetails;
   lenderActionRequired: InsuranceAcquisitionDetails;
   currentMonth: number;

   tableNoAcqsnDealsMessage: string;
   dusGatewayDealSelectionSelectedItem: any[];

   showAcqnTableEditCheckbox: boolean = false;
   acqntbl: any = null;

   startPeriodSelectionText: string;
   endPeriodSelectionText: string;
   monthNames: any[];
   selectStartPeriod: any[] = [];
   selectEndPeriod: any[] = [];
   selectedStartPeriod: string = "";
   selectedEndPeriod: string = "";
   overviewDropdownMenu: any[] = [];
   selectedOverviewPeriod: string = "";
   selectedOverviewPeriodAPIFormat: string = "";
   monthDiff: number;
   monthDiffFutureDate: number;
   countDataFilesList = 0;

   notice: any = null;

   dataFilesTabSelected: boolean = false;

   systemNotificationFlagValue = {};
   showSystemNotification = false;

   showTabLenderRanking: boolean = false;
   showTabAcquisitions: boolean = false;
   showTabDataFiles: boolean = false;
   showTabActionRequired: boolean = false;

   //User flags
   isInternal: boolean = false;
   isExternalUser: boolean = false;
   isAdminUser: boolean = false;
   isMFOpsUser: boolean = false;
   isInsuranceUser: boolean = false;
   isAssetManager: boolean = false;
   isMAUser: boolean = false;

   tab_menu_items: MenuItem[];
   active_menu_item: string;
   active_menu_item_number: number;

   //Define which sidebar component to show
   openedSidebar: boolean = false;
   showSideBarFilter: boolean = true;
   showSideBarAcquisitionPropertyDetails: boolean = true;

   sidebarStyle = { 'background-color': 'white', 'color': 'black', 'padding': '25px', 'border-style': 'inset' };
   sideBarWidth = '0';
   sideBarHeight = '0';

   selectedPropertyName: string;
   selectedDusDealId: string;
   selectedColtRefNo: string;
   selectedAqsnDealId: string;
   selectedPropertyMasterNumber: string;
   selectedTransType: string;
   selectedSSN: string;
   selectedPropId: string;
   selectedCmmtNo: string;
   selectedFloodInsrReqdFlag: boolean;
   showUploadFiles: boolean = false;
   selectedPropertyDetails: any;
   requireFloodINSSelected = '';

   constructor(@Inject(LOCALE_ID) public locale: string,
     private dashboardService: DashboardService, private router: Router,
     private apiService: ApiService, private fileUploadService: FileUploadService,
     private endpointsService: EndpointsService, private _http: HttpClient,
     private route: ActivatedRoute, private sellerServiceNumberService: SellerServiceNumberService,
     private confirmationService: ConfirmationService, private utils: Utils,
     private docWayDetailsService: DocWayDetailsService,
     private acqnFiltersService: AcqnFilterService,
     private statsDataService: StatsDataService,
     private launchDarkly: LaunchDarklyUtil,
     private userRolesService: UserRolesService,
     private aqsnPropertyDetailsService: AqsnPropertyDetailsService,
     private insuranceService: InsuranceService) {
     this.getScreenSize();
   }

   ngOnInit() {
     this.acqnFiltersService.acqnInsuranceFiltersDetailsSub.subscribe((acqnFiltersDetails: AcqnFiltersDetails) => {
       console.log("insurance.component.ts::ngOnInit - call acqnInsuranceFiltersDetailsSub.subscribe ");

       if (acqnFiltersDetails.source.includes(FilterDetailsSourceType.AcqnInsuranceFilter)) {
        this.requireFloodINSSelected = '';

         if (acqnFiltersDetails.source.includes(FilterDetailsSourceType.INSAcq)) {
           this.selectedStartPeriod = acqnFiltersDetails.startPeriod;
           this.selectedEndPeriod = acqnFiltersDetails.endPeriod;
           this.requireFloodINSSelected =  acqnFiltersDetails.requireFloodINS;
           this.getAcquisitionDeals(false);
         } else if (acqnFiltersDetails.source.includes(FilterDetailsSourceType.INSLenderRanking)) {
           this.selectedStartPeriod = acqnFiltersDetails.startPeriod;
           this.selectedEndPeriod = acqnFiltersDetails.endPeriod;
           this.getAcquisitionDeals(true);
         } else if (acqnFiltersDetails.source.includes(FilterDetailsSourceType.INSDataFiles)) {
           this.dataFilesSelectedLender = acqnFiltersDetails.lender;
           this.filterBasedOnLenderName({ value: this.dataFilesSelectedLender }, DDTabName.DataFiles)
         }
       }
     });

     this.initLaunchDarkly();

     this.userId = this.apiService.getUserDetails().uid;
     this.cfmlycode = this.apiService.getUserDetails().corporateFamilyCode;
     this.roles = this.apiService.getUserDetails().groups;
     this.isExternalUser = this.apiService.getUserDetails().isExternalUser;

     //Set MFOps/MFAssetManager/M&AUser Flags
     this.isMFOpsUser = this.userRolesService.isMFOpsUser(this.roles);
     this.isInsuranceUser = this.userRolesService.isInsuranceUser(this.roles);
     if (this.isInsuranceUser) {
       this.showAcqnTableEditCheckbox = true;
     }
     this.isAssetManager = this.userRolesService.isAssetManager(this.roles);
     this.isMAUser = this.userRolesService.isMAUser(this.roles);
     this.isAdminUser = this.userRolesService.isDigitizerAdmin(this.roles);

     //set flags and variables
     this.selected = 0;
     this.fileUploadService.disableUpload = false;
     this.fileUploadService.rejectedFiles = [];
     this.showWarnings = false;
     this.showErrors = false;
     this.fileRejectedError = false;
     this.fileRejectedErrorWarning = false;
     this.fileWarning = false;
     this.masterRecord = false;
     this.showIssueSummary = false;
     this.showIssueSummaryPreview = false;
     this.tableSubtitle = AppConstants.DD_TABLE_SUBTITLE;
     this.tableNoSubmittedFilesMessage = AppConstants.DD_TABLE_NO_SUBMITTED_FILES_MESSAGE;

     //Gather details from docway
     this.docWayDetailsService.getDetails();

     this.showWarnings = false;
     this.showErrors = false;
     this.fileRejectedError = false;
     this.fileRejectedErrorWarning = false;
     this.fileWarning = false;
     this.masterRecord = false;

     //Acquisition Tab variables
     this.startPeriodSelectionText = AppConstants.START_PERIOD_SELECTION_TEXT;
     this.endPeriodSelectionText = AppConstants.END_PERIOD_SELECTION_TEXT;
     this.monthNames = ["January", "February", "March", "April", "May", "June",
       "July", "August", "September", "October", "November", "December"];

     let tempDate = new Date();

     this.monthDiff = this.calculateMonths(new Date(AppConstants.START_PERIOD_DD), tempDate);
     this.monthDiffFutureDate = 12;

     this.selectedStartPeriod = 'January ' + tempDate.getFullYear();

     this.getEndPeriodDates(true, false);
     this.getEndPeriodDates(true, true);

     //this.selectedEndPeriod = tempDate.toDateString();
     this.selectedEndPeriod = "";

     this.tableNoAcqsnDealsMessage = AppConstants.ACQSN_TABLE_NO_ACQSN_DEALS_MESSAGE;

     this.currentMonth = (new Date().getMonth() + 1);

     this.navigationLinks = [
       {
         href: '/',
         label: 'Home'
       },
       {
         href: '#',
         label: 'Due Diligence Reports'
       }
     ];

     this.cols1 = [
       { field: 'name', header: 'Username' },
       { field: 'ssn', header: 'Seller Servicer Number' },
       { field: 'org', header: 'Lender Name' }
     ];

     this.cols2 = [
       { field: 'mf_deal_id', header: 'Deal ID' },
       { field: 'mf_doc_type', header: 'Report Type' },
       { field: 'mfcd_deal_name', header: 'Deal Name' }
     ];

     this.cols3 = [
       { field: 'propNme', header: 'Property Name', width: '16%' },
       { field: 'dusDealId', header: 'DUS Gateway Deal ID', width: '13%' },
       { field: 'fileNM', header: 'File Name', width: '19%' },
       { field: 'collateralNBR', header: 'Collateral Reference #', width: '13%' },
       { field: 'acqnDealId', header: 'Acquisition Deal ID', width: '13%' },
       { field: 'fileSenderNM', header: 'Submitted By', width: '11%' },
       { field: 'submitDT', header: 'Submission On (ET)', width: '13%' }
     ];

     this.cols3_bpo = [
       { field: 'fileNM', header: 'File Name', width: '20%' },
       { field: 'reportType', header: 'Report Type', width: '10%' },
       { field: 'fileType', header: 'File Format', width: '10%' },
       { field: 'collateralNBR', header: 'Collateral Reference #', width: '20%' },
       { field: 'fileSenderNM', header: 'Submitted By', width: '20%' },
       { field: 'submitDT', header: 'Submission On (ET)', width: '20%' }
     ];

     this.cols4 = [
       { field: 'filename', header: 'File' },
       { field: 'status', header: 'Submission Eligibility' },
       { field: 'issueSummary', header: 'Issue Summary' },
       { field: 'receivedDT', header: 'Upload Details' }
     ];

     this.currentStep = 'UploadFileStep';
     this.steps = [
       {
         url: 'UploadFileStep',
         title: 'Upload Files'
       },
       {
         url: 'ReviewFileSummaryStep',
         title: 'Review File Summary'
       }];

     if (this.apiService.getUserDetails().isExternalUser) {
       this.isInternal = false;
       this.sellerServiceNumberService.getSellerServiceNumber(this.userId).subscribe
         ((sellerServicerData: SellerServicerData[]) => {
           this.sellerServicerDataArray = sellerServicerData;
           this.sellerServicerNumber = this.apiService.getSellerServicerNumber();

           //Place all SSN's in a string
           if (this.sellerServicerDataArray[0].sellerServicerNum) {
             let tmpSSNArray = [];
             let tmpSSNParentArray = [];
             for (let i = 0; i < this.sellerServicerDataArray.length; i++) {
               if (this.sellerServicerDataArray[i].sellerServicerNum && !tmpSSNArray.includes(this.sellerServicerDataArray[i].sellerServicerNum)) {
                 tmpSSNArray.push(this.sellerServicerDataArray[i].sellerServicerNum);
               }
               if (this.sellerServicerDataArray[i].sellerServicerNum && !tmpSSNParentArray.includes(this.sellerServicerDataArray[i].sellerServicerNum.substring(0, 5))) {
                 tmpSSNParentArray.push(this.sellerServicerDataArray[i].sellerServicerNum.substring(0, 5));
               }
               this.sellerServicerNumber.sellerServicerNo = tmpSSNArray.join(',');
               this.sellerServicerNoParent = tmpSSNParentArray.join(',');
             }
           } else {
             this.sellerServicerNumber.sellerServicerNo = '';
             this.sellerServicerNoParent = '';
           }

           // Place corporate code
           if (this.sellerServicerDataArray[0].corporateFamily) {
             this.cfmlycode = this.sellerServicerDataArray[0].corporateFamily;
           }
           this.apiService.saveSellerServicerNumber(this.sellerServicerNumber);
           this.userDetails = this.apiService.getUserDetails();
           this.lenderName = this.apiService.getUserDetails().subscriberName;

           this.getUserInformation();
           this.acqnDetails = {
             acqInsuranceDetails: [],
             lenderNames: []
           };
           this.getAcquisitionDeals(false);
           this.loadActionRequiredData();
         },
           err => {
             // We don't want customer to continue if there is an error getting SSNs.
             if (err.status === 400 && err.message.contains("doesn't have access")) {
               this.router.navigate(['un-authorized']);
             } else {
               this.router.navigate(['error']);
             }
           });
     } else {
       this.isInternal = true;
       this.sellerServicerNumber = this.apiService.getSellerServicerNumber();
       this.sellerServicerNumber.sellerServicerNo = '';
       this.sellerServicerNoParent = '';
       this.apiService.saveCorporateFamily('');
       this.lenderName = "Fannie Mae";
       this.getUserInformation();
       // disable if they have READONLY roles
       if (this.roles && this.roles.length > 0) {
         this.roles.forEach(role => {
           let roleName: String = role.toString();
           if (roleName.indexOf('SG-GA6-MFDIGITIZER-UAT-ReadOnly') == 0) {
             this.disableUpload = true;
           } else if (roleName.indexOf('SG-GA6-MFDIGITIZER-PROD-ReadOnly') == 0) {
             this.disableUpload = true;
           }
         });
       }
       // enable if they have dual role (TEMPORARILY)
       if (this.roles && this.roles.length > 0) {
         this.roles.forEach(role => {
           let roleName: String = role.toString();
           if (roleName.indexOf('SG-GA6-MFDIGITIZER-UAT-ReadWrite') == 0) {
             this.disableUpload = false;
           } else if (roleName.indexOf('SG-GA6-MFDIGITIZER-PROD-ReadWrite') == 0) {
             this.disableUpload = false;
           }
         });
       }
       this.acqnDetails = {
         acqInsuranceDetails: [],
         lenderNames: []
       };
       if ((this.isAssetManager || this.isMAUser) && !this.isAdminUser) {
         this.isLoadingInsurance = true;
         this.getSubmittedInsuranceFilesData(this.userId, "", "", this.cfmlycode, "");
       } else {
         this.getAcquisitionDeals(true);
       }
     }

     // Pass user roles to service
     this.userRolesService.updateUserDetails({
       isInternal: this.isInternal,
       isExternalUser: this.isExternalUser,
       isAdminUser: this.isAdminUser,
       isMFOpsUser: this.isMFOpsUser,
       isAssetManager: this.isAssetManager,
       isMAUser: this.isMAUser
     });

     // Force a reload of the page to get the latest acquisition data
     this.setShowTabs()
     this.loadTabData({ index: 1, label: this.active_menu_item });
   }

   ngAfterViewInit() {
     // Code to be executed after the view is initialized
     this.updateActionRequiredBadge();
   }

   private updateActionRequiredBadge() {
     if (this.showTabActionRequired) {

       // Find the action required tab and add a badge with number of actions to take
       const textToFind = DDTabName.ActionRequired;
       const xpathExpression = `//*[text()='${textToFind}']`;
       const result = document.evaluate(xpathExpression, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);
       const elementActionReq = result.singleNodeValue;

       if (elementActionReq) {
         // Prevent duplicate display of badge with id='count_action_required_badge'
         const elementBadge = document.getElementById('count_action_required_badge');
         if (elementBadge) {
           elementBadge.remove();
         }

         // Create and insert badge
         const htmlElementActionReq = elementActionReq as HTMLElement;
         let countBadgeActionRequired = this.lenderActionRequired.acqInsuranceDetails.length;

         let htmlString = '&nbsp;<span id="count_action_required_badge" style="font-size: 14px; background-color: #D02F2F; color: white; padding: 3px 10px 5px 12px; text-align: center; border-radius: 25px;">' + countBadgeActionRequired + '</span>';
         htmlElementActionReq.insertAdjacentHTML('afterend', htmlString);
       }
     }
   }

   private setShowTabs() {
     this.showTabLenderRanking = this.isInternal;
     this.showTabAcquisitions = true;
     this.showTabDataFiles = true;
     this.showTabDataFiles = true;
     this.showTabActionRequired = this.isExternalUser;

     if (this.isMAUser && !this.isAdminUser) {
       this.showTabLenderRanking = false;
       this.showTabAcquisitions = false;
       this.showTabDataFiles = true;
     }

     if (this.isAssetManager && !this.isAdminUser) {
       this.showTabLenderRanking = false;
     }

     this.setTabMenuItems();
   }

   private setTabMenuItems() {
     let isSetActiveMenu = false;
     this.tab_menu_items = [];

     isSetActiveMenu = this.setMenuAndActiveMenu(this.showTabActionRequired, DDTabName.ActionRequired, isSetActiveMenu);
     isSetActiveMenu = this.setMenuAndActiveMenu(this.showTabLenderRanking, DDTabName.LenderRanking, isSetActiveMenu);
     isSetActiveMenu = this.setMenuAndActiveMenu(this.showTabAcquisitions, DDTabName.Acquisitions, isSetActiveMenu);
     isSetActiveMenu = this.setMenuAndActiveMenu(this.showTabDataFiles, DDTabName.DataFiles, isSetActiveMenu);
   }

   private calculateActiveMenuItemNumber(active_menu_item: string) {
     for (let i = 0; i < this.tab_menu_items.length; i++) {
       if (this.tab_menu_items[i].label == active_menu_item) {
         this.active_menu_item_number = i;
         break;
       }
     }

    //  console.log("active_menu_item: " + this.active_menu_item);
    //  console.log("active_menu_item_number: " + this.active_menu_item_number);
   }

   private setMenuAndActiveMenu(showMenu: boolean, labelName: string, isSetActiveMenu: boolean) {
     if (showMenu) {
       this.tab_menu_items.push({ label: labelName });
       if (!isSetActiveMenu) {
         this.active_menu_item = labelName;
         isSetActiveMenu = true;
       }
     }
     return isSetActiveMenu;
   }

   public loadTabData(event) {
     this.showUploadFiles = false;
     this.onClickCloseSidebar();

     this.active_menu_item = event.label;
     this.calculateActiveMenuItemNumber(this.active_menu_item);

     if (this.active_menu_item == DDTabName.DataFiles && this.isInternal) {
       //internal Data Files
       this.isLoadingInsurance = true;
       this.getSubmittedInsuranceFilesData(this.userId, "", "", this.cfmlycode, "");
     } else if (this.active_menu_item == DDTabName.DataFiles && !this.isInternal) {
       //external Data Files
       //this.getSubmittedInsuranceFilesData = true;
       this.getSubmittedInsuranceFilesData(this.userId, this.docWayDetailsService.mf_deal_id, this.docWayDetailsService.mf_doc_type, this.cfmlycode, this.sellerServicerNoParent);
     } else if ((this.active_menu_item == DDTabName.Acquisitions && !this.isInternal) || (this.active_menu_item == DDTabName.Acquisitions && this.isInternal)) {
       //internal and external Acquisitions
       this.acqnDetails = {
         acqInsuranceDetails: [],
         lenderNames: []
       };
       this.getAcquisitionDeals(false);
     } else if (this.active_menu_item == DDTabName.LenderRanking && this.isInternal) {
       //internal Lender Ranking
       this.acqnDetails = {
         acqInsuranceDetails: [],
         lenderNames: []
       };
       this.getAcquisitionDeals(true);
     }

     this.updateActionRequiredBadge();
   }

   public getUserInformation() {
     this.userInfoArray = this.dashboardService.getUserInformation();
   }

   public filterBasedOnLenderName(event, tab) {
     if (tab == DDTabName.DataFiles) {
       this.dataFilesDetailsDashboardDisplay = [];
       if (event.value == '') {
         for (let i = 0; i < this.dataFilesDetails.dataFilesDashboardDetails.length; i++) {
           this.dataFilesDetailsDashboardDisplay.push(this.dataFilesDetails.dataFilesDashboardDetails[i]);
         }
         this.countDataFilesList = this.dataFilesDetailsDashboardDisplay.length;
       } else {
         for (let j = 0; j < this.dataFilesDetails.dataFilesDashboardDetails.length; j++) {
           if (this.dataFilesDetails.dataFilesDashboardDetails[j].lender == event.value) {
             this.dataFilesDetailsDashboardDisplay.push(this.dataFilesDetails.dataFilesDashboardDetails[j]);
           }
         }
         this.countDataFilesList = this.dataFilesDetailsDashboardDisplay.length;
       }
     }
   }

   public getAcquisitionDeals(isLenderRanking: boolean) {
     let startDateTemp = new Date(this.selectedStartPeriod);
     let formattedStartDate = (startDateTemp.getMonth() + 1).toString() + '/' + startDateTemp.getFullYear().toString();

     let formattedEndDate = "";
     if (this.selectedEndPeriod != "") {
       let endDateTemp = new Date(this.selectedEndPeriod);
       formattedEndDate = (endDateTemp.getMonth() + 1).toString() + '/' + endDateTemp.getFullYear().toString();
     }


     this.isLoadingInsurance = true;
     this.getAcqInsuranceData(formattedStartDate, formattedEndDate, isLenderRanking);
   }

   public getAcqInsuranceData(startDate: string, endDate: string, isLenderRanking: boolean) {
     this.dashboardService.getAcqInsuranceData(this.sellerServicerNumber.sellerServicerNo, startDate, endDate, this.isInternal).subscribe(
       (res: InsuranceAcquisitionDetails) => {
         this.acqnDetails = res;
       },
       err => {
         this.showAlertFeedback("error", AppConstants.GENERAL_ERROR_MSG_SERVER);
         this.acqnDetails.acqInsuranceDetails = [];
         this.acqnDetails.lenderNames = [];
         this.isLoadingInsurance = false;
       },
       () => {
        if (this.acqnDetails.acqInsuranceDetails) {
          for (let i = 0; i < this.acqnDetails.acqInsuranceDetails.length; i++) {
            if (this.acqnDetails.acqInsuranceDetails[i].aqsnDt)
              this.acqnDetails.acqInsuranceDetails[i].aqsnDt = new Date(this.acqnDetails.acqInsuranceDetails[i].aqsnDt);
            else if (this.acqnDetails.acqInsuranceDetails[i].bkEntDt)
              this.acqnDetails.acqInsuranceDetails[i].aqsnDt = new Date(this.acqnDetails.acqInsuranceDetails[i].bkEntDt);
            if (this.acqnDetails.acqInsuranceDetails[i].reqdSubmtDt)
              this.acqnDetails.acqInsuranceDetails[i].reqdSubmtDt = new Date(this.acqnDetails.acqInsuranceDetails[i].reqdSubmtDt);
            if (this.acqnDetails.acqInsuranceDetails[i].propInsrSubmtDt)
              this.acqnDetails.acqInsuranceDetails[i].propInsrSubmtDt = new Date(this.acqnDetails.acqInsuranceDetails[i].propInsrSubmtDt);

            if (this.acqnDetails.acqInsuranceDetails[i].fileRcvdDttmINSR)
              this.acqnDetails.acqInsuranceDetails[i].fileRcvdDttmINSR = new Date(this.acqnDetails.acqInsuranceDetails[i].fileRcvdDttmINSR);
          }
        }
        //default sort by date
        this.acqnDetails.acqInsuranceDetails = _.sortBy(this.acqnDetails.acqInsuranceDetails, ['aqsnDt']).reverse();
        this.isLoadingInsurance = false;

        this.onUpdateLenderStats(this.acqnDetails.acqInsuranceDetails);
      }
    );
  }

  onUpdateLenderStats(acqInsuranceDetails) {
    let lenderStats = this.insuranceService.complianceCalculationInsurance(acqInsuranceDetails, this.requireFloodINSSelected);
    this.statsDataService.setStatsDataDetails(lenderStats);
    this.statsDataService.notifySubscribers();
  }

   private parseDate(dateString: string | Date): Date | null {
     if (!dateString) return null;

     // Check if the input is already a Date object
     if (dateString instanceof Date) return dateString;

     // Convert the input to a string
     const dateStr = dateString.toString().trim();

     // Handle YYYY-MM-DD format
     if (dateStr.includes('-')) {
       const [year, month, day] = dateStr.split('-').map(Number);
       return new Date(year, month - 1, day); // Month is zero-based in JavaScript
     }

     // Handle MM/DD/YYYY format
     if (dateStr.includes('/')) {
       const [month, day, year] = dateStr.split('/').map(Number);
       return new Date(year, month - 1, day); // Month is zero-based in JavaScript
     }

     // Return null if the format is unrecognized
     return null;
   }

   public loadActionRequiredData() {

     console.log("insurance-dashboard.component::loadActionInsuranceRequiredData - making API call");

     this.dashboardService.getLenderInsuranceActionRequiredData(this.sellerServicerNumber.sellerServicerNo).subscribe(
       (res: InsuranceAcquisitionDetails) => {
         this.lenderActionRequired = res;
       },
       err => {
         this.showAlertFeedback("error", AppConstants.GENERAL_ERROR_MSG_SERVER);
         this.isLoadingInsurance = false;
        //  this.lenderActionRequired.acqInsuranceDetails = [];
         this.showTabActionRequired = false;
         this.setTabMenuItems();
       },
       () => {
         if (this.lenderActionRequired.acqInsuranceDetails) {
           if (this.lenderActionRequired.acqInsuranceDetails.length == 0) {
             this.showTabActionRequired = false;
             this.setTabMenuItems();
             return;
           }

           for (let i = 0; i < this.lenderActionRequired.acqInsuranceDetails.length; i++) {
             if (this.lenderActionRequired.acqInsuranceDetails[i].aqsnDt)
               this.lenderActionRequired.acqInsuranceDetails[i].aqsnDt = new Date(this.lenderActionRequired.acqInsuranceDetails[i].aqsnDt);
             else if (this.lenderActionRequired.acqInsuranceDetails[i].bkEntDt)
               this.lenderActionRequired.acqInsuranceDetails[i].aqsnDt = new Date(this.lenderActionRequired.acqInsuranceDetails[i].bkEntDt);
             if (this.lenderActionRequired.acqInsuranceDetails[i].reqdSubmtDt)
               this.lenderActionRequired.acqInsuranceDetails[i].reqdSubmtDt = new Date(this.lenderActionRequired.acqInsuranceDetails[i].reqdSubmtDt);
             if (this.lenderActionRequired.acqInsuranceDetails[i].propInsrSubmtDt)
               this.lenderActionRequired.acqInsuranceDetails[i].propInsrSubmtDt = new Date(this.lenderActionRequired.acqInsuranceDetails[i].propInsrSubmtDt);
           }
           this.lenderActionRequired.acqInsuranceDetails = Acquisitions_Util.sortByDate(this.lenderActionRequired.acqInsuranceDetails);


           this.showTabActionRequired = true;
           this.setTabMenuItems();

           // Schedule another function to run 0.5 seconds later
           setTimeout(() => {
             this.updateActionRequiredBadge();
           }, 500); // 500 milliseconds = 0.5 seconds

         } else {
           this.showTabActionRequired = false;
           this.setTabMenuItems();
           return;
         }
       }
     );
   }

   public getSubmittedInsuranceFilesData(userId, dealId, reportType, cfmlycode, parentSSNList) {
     this.dashboardService.getSubmittedInsuranceFilesData(userId, dealId, reportType, cfmlycode, parentSSNList, this.utils.getUserType(this.isInternal, this.isAssetManager, this.isMAUser, this.isMFOpsUser)).subscribe(
       (res: DataFilesDetails) => {
         this.dataFilesDetails = res;
         if (this.dataFilesDetails.dataFilesDashboardDetails == null) {
           this.dataFilesDetails.dataFilesDashboardDetails = [];
         }
         if (this.dataFilesDetails.lenderNames == null) {
           this.dataFilesDetails.lenderNames = [];
         }
         this.countDataFilesList = this.dataFilesDetails.dataFilesDashboardDetails.length;
       },
       err => {
         this.showAlertFeedback("error", AppConstants.GENERAL_ERROR_MSG_SERVER);
        //  this.dataFilesDetails.dataFilesDashboardDetails = [];
        //  this.dataFilesDetails.lenderNames = [];
         this.isLoadingInsurance = false;
       },
       () => {
         if (this.dataFilesDetails.dataFilesDashboardDetails) {
           this.dataFilesDetailsDashboardDisplay = this.dataFilesDetails.dataFilesDashboardDetails;
           for (let i = 0; i < this.dataFilesDetailsDashboardDisplay.length; i++) {
             this.dataFilesDetailsDashboardDisplay[i].submitDT = new Date(this.dataFilesDetailsDashboardDisplay[i].submitDT);
           }
         } else {
           this.dataFilesDetailsDashboardDisplay = [];
         }
         this.dataFilesLenderList = [{ label: 'All', value: '' }];
         if (this.dataFilesDetails.lenderNames) {
           for (let i = 0; i < this.dataFilesDetails.lenderNames.length; i++) {
             this.dataFilesLenderList.push({ label: this.dataFilesDetails.lenderNames[i], value: this.dataFilesDetails.lenderNames[i] });
           }
           this.dataFilesLenderList = _.sortBy(this.dataFilesLenderList, ['value']);
         } else {
           this.dataFilesLenderList = [{ label: 'All', value: '' }];
         }
         this.isLoadingInsurance = false;
       }
     );
   }

   public getFilesData(objectKey, validationonly): Promise<void> {
     return new Promise<void>((resolve) => {
     this.dashboardService.getFilesData(objectKey, this.userId, this.cfmlycode, validationonly, this.utils.getUserType(this.isInternal, this.isAssetManager, this.isMAUser, this.isMFOpsUser),
       this.selectedPropertyName, this.selectedDusDealId, this.selectedColtRefNo, this.selectedAqsnDealId, this.selectedPropertyMasterNumber, 
       this.selectedTransType, this.selectedSSN, this.selectedPropId, this.selectedCmmtNo, this.apiService.getUserDetails().fmFederationID).subscribe(
         (uploadedFilesData: UploadedFilesData) => {
           if (uploadedFilesData) {
             this.calculateIssueSummary(uploadedFilesData.fileStatus.errorsList);
             let fileStatus = {
               "fileStatus": {
                 "objectKey": uploadedFilesData.fileStatus.objectKey,
                 "status": uploadedFilesData.fileStatus.status,
                 "userid": uploadedFilesData.fileStatus.userid,
                 "issueSummary": this.issueSummary,
                 "receivedDT": uploadedFilesData.fileStatus.receivedDT == null ? "" : uploadedFilesData.fileStatus.receivedDT,
                 "errorsList": uploadedFilesData.fileStatus.errorsList
               },
               "reportedFields": uploadedFilesData.reportedFields
             };
             this.persistFileStatus(validationonly, fileStatus);
           }
         },
         err => {
           //TODO: Handle getFilesData Errors
           //For now just create a mock error message and push it to uploaded files array
           let mockErrorMessage = {
             "fileStatus": {
               "objectKey": objectKey,
               "status": "Error",
               "userid": null,
               "receivedDT": "",
               "errorsList": null
             },
             "reportedFields": [
               {
                 "displayName": "",
                 "type": ""
               }
             ]
           };
           if (validationonly) {
             this.uploadedFilesArray.push(mockErrorMessage);
             this.hideSpinner(this.uploadedFilesArray.length, this.selectedFileCount);
             if (!this.isLoading) {
               this.uploadedFilesArray = [];
               this.currentStep = "ReviewFileSummaryStep";
             }
           } else {
             this.submittedFilesArray.push(mockErrorMessage);
             this.hideSpinner(this.submittedFilesArray.length, this.selectedFilesArray.length);
           }
           this.editFileNames();
           resolve();
         },
         () => {
           this.editFileNames();
           this.updateTable();
           resolve();
         }
       );
     });
   }

   public processFileUpload(event: any) {
     this.dashboardService.processFileUpload(event).subscribe(
       res => {
         console.log(res);
       },
       error => {
         console.error(error);
       }
     )
   }

   persistFileStatus(validationonly, fileStatus) {
     if (validationonly) {
       this.uploadedFilesArray.push(fileStatus);
       this.uploadedFilesArrayTemp.push(fileStatus);
       this.uploadedFilesArrayDisplay.push({
         "objectKey": fileStatus.fileStatus.objectKey,
         "status": fileStatus.fileStatus.status,
         "userid": fileStatus.fileStatus.userid,
         "issueSummary": fileStatus.fileStatus.issueSummary,
         "receivedDT": fileStatus.fileStatus.receivedDT == null ? "" : fileStatus.fileStatus.receivedDT,
         "errorsList": fileStatus.fileStatus.errorsList
       });
       this.hideSpinner(this.uploadedFilesArray.length, this.selectedFileCount);
     } else {
       this.submittedFilesArray.push(fileStatus);
       this.hideSpinner(this.submittedFilesArray.length, this.selectedFilesArray.length);
     }
   }

   // Fix Me: TO DO: Do we need to go through entire list all the time?
   // We don't need it as we are polling one file at a time.
   editFileNames() {
     this.originalName = "";
     this.newNameSplit = [];
     this.newName = "";
     for (let i = 0; i < this.uploadedFilesArrayDisplay.length; i++) {
       this.originalName = this.uploadedFilesArrayDisplay[i].objectKey;
       if (this.originalName && this.originalName.includes("___")) {
         this.newNameSplit = this.originalName.split("___");
         this.newName = this.newNameSplit[1];
         this.uploadedFilesArrayDisplay[i].filename = this.newName;
       }
     }
     this.fileUploadService.setReviewFileSummaryTableData(this.uploadedFilesArrayDisplay);
   }

   onHide() {
     console.log("onHide");
     this.showUploadFiles = false;
     this.isLoadingInsurance = true;
     this.fileUploadService.disableUpload = true;
     this.fileUploadService.onClearFile();
     this.uploadedFilesArray = [];
     this.uploadedFilesArrayTemp = [];
     this.uploadedFilesArrayDisplay = [];
     this.selectedFilesArray = [];
     this.currentStep = 'UploadFileStep';
     this.getSubmittedInsuranceFilesData(this.userId, this.docWayDetailsService.mf_deal_id, this.docWayDetailsService.mf_doc_type, this.cfmlycode, this.sellerServicerNoParent);
     
     // This will clear the cache for fil upload table betwee uploads. 
     this.fileUploadService.setReviewFileSummaryTableData([]);
   }

   updateTable() {
     console.log("update table");
     this.isLoadingInsurance = true;
     this.fileUploadService.disableUpload = true;
     this.fileUploadService.onClearFile();
     //this.fileUploadService.setReviewFileSummaryTableData(this.uploadedFilesArrayDisplay);
     this.getSubmittedInsuranceFilesData(this.userId, this.docWayDetailsService.mf_deal_id, this.docWayDetailsService.mf_doc_type, this.cfmlycode, this.sellerServicerNoParent);

     //After file upload completed
     if (this.fileUploadService.getFileUploadDetails().completed == true) {
       if (this.fileUploadService.getSource().includes(FileUploadSourceType.AcquisitionPropertyDetails)) {
         console.log('File upload completed, AcquisitionPropertyDetails');
         this.loadTabData({ index: 1, label: this.active_menu_item });
       } else if (this.fileUploadService.getSource().includes(FileUploadSourceType.ActionRequired)) {
         console.log('File upload completed, ActionRequired');
         this.loadActionRequiredData();
       }
     }
   }

   calculateIssueSummary(errorsAndWarnings) {
     this.errorCount = 0;
     this.warningCount = 0;

     let mappedErrors = _.mapValues(errorsAndWarnings, "errors");
     let filteredMappedErrors = _.filter(mappedErrors, _.size);
     let flattenedFilteredMappedErrors = _.flatten(filteredMappedErrors);
     this.errorCount = flattenedFilteredMappedErrors.length;
     let mappedWarnings = _.mapValues(errorsAndWarnings, "warnings");
     let filteredMappedWarnings = _.filter(mappedWarnings, _.size);
     let flattenedFilteredMappedWarnings = _.flatten(filteredMappedWarnings);
     this.warningCount = _.uniq(flattenedFilteredMappedWarnings).length;

     this.issueSummary = this.errorCount + " error(s); " + this.warningCount + " warning(s)";
   }

   @HostListener('window:resize', ['$event'])
   getScreenSize(event?) {
     this.screenHeight = window.innerHeight;
     this.screenWidth = window.innerWidth;
     this.modalScreenHeight = window.innerHeight * 0.60;
     this.modalScreenWidth = window.innerWidth * 0.55;
     this.modalTableHeight = this.modalScreenHeight + "px";
   }

   showAlertFeedback(type: string, message: string) {
     this.alertFeedback = [];
     this.alertFeedback.push({ type: type, message: message });
   }

   hideSpinner(value1, value2) {
     if (value1 == value2)
       this.isLoading = false;
   }

   printScreen() {
     let printContents, printWindow;
     printContents = document.getElementById('print-preview-lender-ranking')?.innerHTML;
     printWindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
     printWindow.document.s
     printWindow.document.open();
     printWindow.document.write(`
        <html>
          <head>
            <title>Lender Ranking Summary</title>
          </head>
          <body onload="window.print();window.close()">${printContents}</body>
        </html>`
     );
     printWindow.document.close();
   }

   calculateMonths(d1, d2) {
     var months;
     months = (d2.getFullYear() - d1.getFullYear()) * 12;
     months -= d1.getMonth();
     months += d2.getMonth();
     return months <= 0 ? 0 : months;
   }

   getEndPeriodDates(onload: boolean, isLenderRanking: boolean) {
     this.selectEndPeriod = [];
     this.alertFeedback = [];

     if (new Date(this.selectedStartPeriod) >= new Date(this.selectedEndPeriod))
       this.selectedEndPeriod = this.selectedStartPeriod;

     if (this.selectedEndPeriod != "" && !onload)
       this.getAcquisitionDeals(isLenderRanking);

     let date = new Date();
     let months = [];
     let startDate = new Date();
     let futureDate = new Date();

     if (this.selectedStartPeriod != "")
       startDate = new Date(this.selectedStartPeriod);
     else
       startDate = new Date(AppConstants.START_PERIOD_DD);

     futureDate.setFullYear(futureDate.getFullYear() + 1);

     if (new Date(this.selectedStartPeriod) <= new Date()) {
       this.monthDiffFutureDate = this.calculateMonths(new Date(), futureDate);
     } else {
       this.monthDiffFutureDate = this.calculateMonths(startDate, futureDate);
     }
     //add future months
     for (let i = 0; i <= this.monthDiffFutureDate; i++) {
       months.push(this.monthNames[futureDate.getMonth()] + ' ' + futureDate.getFullYear());
       futureDate.setMonth(futureDate.getMonth() - 1);
     }

     //add past months
     if (new Date(this.selectedStartPeriod) <= new Date()) {
       for (let i = 0; i <= this.monthDiff; i++) {
         if ((this.monthNames[date.getMonth()] + ' ' + date.getFullYear()) == (this.monthNames[startDate.getMonth()]
           + ' ' + startDate.getFullYear())) {
           months.push(this.monthNames[date.getMonth()] + ' ' + date.getFullYear());
           break;
         } else {
           months.push(this.monthNames[date.getMonth()] + ' ' + date.getFullYear());
           date.setMonth(date.getMonth() - 1);
         }
       }
     }
     months = Array.from(new Set(months));
     for (let i = 0; i < months.length; i++) {
       this.selectEndPeriod.push({ label: months[i], value: months[i] });
     }
     this.selectEndPeriod.push({ label: "", value: "" });
     _.reverse(this.selectEndPeriod)
   }

   onRefreshAcqnDetails(event: { startDate: string; endDate: string; isLenderRanking: boolean; }) {
     this.selectedStartPeriod = event.startDate;
     this.selectedEndPeriod = event.endDate;
     this.getAcquisitionDeals(event.isLenderRanking);
   }

   onGetEndPeriodDates(event: { startDate: string; endDate: string; onload: any; isLenderRanking: any; }) {
     this.selectedStartPeriod = event.startDate;
     this.selectedEndPeriod = event.endDate;
     let onload = event.onload;
     let isLenderRanking = event.isLenderRanking;
     this.getEndPeriodDates(onload, isLenderRanking);
     this.getAcquisitionDeals(isLenderRanking);
   }

   onOpenAcqnFilterSidebar() {
     this.sideBarWidth = '600';
     this.sideBarHeight = '1024';

     this.openedSidebar = true;
     this.showSideBarFilter = true;
     this.showSideBarAcquisitionPropertyDetails = false;
   }

   onOpenAcqnPropertyDetailsSidebar() {
     this.sideBarWidth = '600';
     this.sideBarHeight = '1024';
     this.openedSidebar = true;
     this.showSideBarFilter = false;
     this.showSideBarAcquisitionPropertyDetails = true;

     this.aqsnPropertyDetailsService.setSelectedPropertyDetails(this.selectedPropertyDetails);
     this.aqsnPropertyDetailsService.notifySubscribers();
   }

   onClickCloseSidebar() {
     this.showUploadFiles = false;
     this.openedSidebar = false;
     this.showSideBarFilter = true;
     this.showSideBarAcquisitionPropertyDetails = true;
     this.acqnFiltersService.setSource('');
   }

   showDataFilesFilterSidebar() {
     this.onOpenAcqnFilterSidebar();
     this.acqnFiltersService.setSource(FilterDetailsSourceType.INSDataFiles);
     this.acqnFiltersService.setIsInternal(this.isInternal);
     this.acqnFiltersService.setLender(this.dataFilesSelectedLender);
     this.acqnFiltersService.setLenderList(this.dataFilesLenderList);

     this.acqnFiltersService.notifySubscribers();
   }

   initLaunchDarkly() {
     this.launchDarkly.getLaunchDarklyNotification(this, this.launchDarklyCallback)
   }

   launchDarklyCallback(systemNotificationFlagValue, caller) {
     caller.systemNotificationFlagValue = systemNotificationFlagValue;
    //  console.log('LaunchDarkly flag systemNotificationFlagValue = ', caller.systemNotificationFlagValue);
     if (Object.keys(caller.systemNotificationFlagValue).length > 0) {
       caller.showSystemNotification = true;
     }
   }

   launchDarklyCallbackShutdown(systemDownFlagValue: boolean, caller) {
     caller.systemDownFlagValue = systemDownFlagValue;
    //  console.log('LaunchDarkly flag systemDownFlagValue = ', caller.systemDownFlagValue);
     if (Object.keys(caller.systemDownFlagValue).length > 0) {
       caller.router.navigate(['/'], { skipLocationChange: true });
     }
   }

   onGetPropertyFileUploadDetails(event: { selectedPropertyName: string; selectedDusDealId: string; selectedColtRefNo: string; selectedAqsnDealId: string; selectedPropertyMasterNumber: string; selectedTransType: string; selectedSSN: string; selectedPropId: string; selectedCmmtNo: string; selectedFloodInsrReqdFlag: string; }) {
     this.selectedPropertyName = event.selectedPropertyName;
     this.selectedDusDealId = event.selectedDusDealId;
     this.selectedColtRefNo = event.selectedColtRefNo;
     this.selectedAqsnDealId = event.selectedAqsnDealId;
     this.selectedPropertyMasterNumber = event.selectedPropertyMasterNumber;
     this.selectedTransType = event.selectedTransType;
     this.selectedSSN = event.selectedSSN;
     this.selectedPropId = event.selectedPropId;
     this.selectedCmmtNo = event.selectedCmmtNo;
     this.selectedFloodInsrReqdFlag = event.selectedFloodInsrReqdFlag === 'true';
   }

   onGetPropertyFileUploadDetailsFromSidebar(event: { selectedPropertyName: string; selectedDusDealId: string; selectedColtRefNo: string; selectedAqsnDealId: string; selectedPropMstrNo: string; selectedTransType: string; selectedSSN: string; selectedPropId: string; selectedCmmtNo: string; selectedFloodInsrReqdFlag: string; showUploadFiles: boolean }) {
     this.selectedPropertyName = event.selectedPropertyName;
     this.selectedDusDealId = event.selectedDusDealId;
     this.selectedColtRefNo = event.selectedColtRefNo;
     this.selectedAqsnDealId = event.selectedAqsnDealId;
     this.selectedPropertyMasterNumber = event.selectedPropMstrNo;
     this.selectedTransType = event.selectedTransType;
     this.selectedSSN = event.selectedSSN;
     this.selectedPropId = event.selectedPropId;
     this.selectedCmmtNo = event.selectedCmmtNo;
     this.selectedFloodInsrReqdFlag = event.selectedFloodInsrReqdFlag === 'true';
     this.showUploadFiles = event.showUploadFiles;
   }

   onGetSelectedPropertyDetails(event: any) {
     this.selectedPropertyDetails = event;
   }

   public onfilteredDataFilesData(dftbl) {
     const filteredData = dftbl.filteredValue;
     this.countDataFilesList = filteredData?.length || this.dataFilesDetailsDashboardDisplay.length;
   }
 }
